import { render, staticRenderFns } from "./BookingDetailArchivedPage.vue?vue&type=template&id=feacf498&scoped=true&"
import script from "./BookingDetailArchivedPage.vue?vue&type=script&lang=js&"
export * from "./BookingDetailArchivedPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feacf498",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tunabaranurut/Documents/Workgrounds/Cruise/Repo/panel-spa/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('feacf498')) {
      api.createRecord('feacf498', component.options)
    } else {
      api.reload('feacf498', component.options)
    }
    module.hot.accept("./BookingDetailArchivedPage.vue?vue&type=template&id=feacf498&scoped=true&", function () {
      api.rerender('feacf498', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/page/BookingDetailArchivedPage.vue"
export default component.exports